import { render, staticRenderFns } from "./html-to-pdf.vue?vue&type=template&id=427c4536&scoped=true&"
import script from "./html-to-pdf.ts?vue&type=script&lang=ts&"
export * from "./html-to-pdf.ts?vue&type=script&lang=ts&"
import style0 from "./html-to-pdf.scss?vue&type=style&index=0&id=427c4536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c4536",
  null
  
)

export default component.exports